import React, { useState } from "react";

import { useParams } from "react-router-dom";

import styled from "styled-components/macro";

import { NavLink } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";

import AgentForm from "../../components/AgentForm";

import { AgentsService } from "../../services";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

function Private() {
  const [data, setData] = useState([]);

  const { agentId } = useParams();

  React.useEffect(() => {
    (async () => {
      const resList = await AgentsService.getById(agentId);
      setData(resList.data);
    })();
  }, []);

  const handleSubmit = async (form) => {
    if (agentId) {
      await AgentsService.edit(agentId, form);
      alert("Agente atualizado com sucesso");
    } else {
      await AgentsService.create(form);
      alert("Agente cadastrado com sucesso");
    }
  };
  return (
    <Card mb={6}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Preencha os dados abaixo para atualizar os dados
        </Typography>

        <AgentForm data={data} handleSubmit={handleSubmit} />
      </CardContent>
    </Card>
  );
}

export const AgentEditPage = () => {
  return (
    <Box p={8}>
      <Helmet title="Settings" />

      <Typography variant="h3" gutterBottom display="inline">
        Atualizar agente
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          Inicio
        </Link>
        <Link component={NavLink} exact to="/platform/agents">
          Agentes
        </Link>
        <Typography>Atualização de agentes</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Private />
        </Grid>
      </Grid>
    </Box>
  );
};
